// removed by extract-text-webpack-plugin
module.exports = {"list":"content-list__list___34L_D"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Content/List/content-list.scss
// module id = 922
// module chunks = 0